import * as R from 'ramda';
import { useTranslation } from 'react-i18next';
// mui
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
// icons-material
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// ui
import { Button } from '../../ui';
//////////////////////////////////////////////////

const FormFooter = props => {
  const {
    cancelText,
    cancelAction,
    submitBtnStyles,
    title = 'submit',
    isSubmitting = false,
  } = props;

  const {
    width,
    height,
    fontSize,
    borderRadius,
    useIconBtn = false,
    useSubmitBtn = true,
    useCancelBtn = false,
  } = submitBtnStyles;

  const { t } = useTranslation();

  const cancelBtnText = R.or(cancelText, t('actions.cancel'));
  const submitText = R.or(t(`actions.${title}`), t('actions.add'));

  return (
    <Stack
      mt={2}
      direction='row'
      justifyContent='space-between'
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      {
        useCancelBtn && (
          <Button
            width={width}
            type='button'
            variant='light'
            fontWeight='bold'
            id={cancelBtnText}
            title={cancelBtnText}
            onClick={cancelAction}
            disabled={isSubmitting}
            height={R.or(height, 42)}
            fontSize={R.or(fontSize, 18)}
            borderRadius={R.or(borderRadius, 4)}
          >
            {
              isSubmitting
                ? <CircularProgress size={16} color='inherit' />
                : cancelBtnText
            }
          </Button>
        )
      }
      {
        useSubmitBtn && (
          <Button
            type='submit'
            width={width}
            id={submitText}
            variant='primary'
            fontWeight='bold'
            title={submitText}
            disabled={isSubmitting}
            height={R.or(height, 42)}
            fontSize={R.or(fontSize, 18)}
            borderRadius={R.or(borderRadius, 4)}
          >
            {
              isSubmitting
                ? <CircularProgress size={16} color='inherit' />
                : (
                  <>
                    {useIconBtn && <AddCircleOutlineIcon sx={{ mr: 1, mb: '-1.5px', fontSize: 16 }} />}
                    {submitText}
                  </>
                )
            }
          </Button>
        )
      }
    </Stack>
  );
};

export default FormFooter;
